import { Time } from '@mobiscroll/react'

import './index.css'

export default Time